import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { isMicrosoftLoginDisabled } from "../../auth/msalConfig";
import { postPlusLegacyLogin } from "../../services/apiService";

const legacyLoginUrl = (process.env.REACT_APP_LOGIN_SERALOGIN_URL || "").trim();

const Login = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("Validando acceso legacy...");

  useEffect(() => {
    let mounted = true;
    const urlParams = new URLSearchParams(window.location.search);
    const id_usuario = urlParams.get("id_usuario");
    const inicio = urlParams.get("inicio");
    const fin = urlParams.get("fin");
    const totales = Number(urlParams.get("totales") || 0);

    const redirectToMicrosoft = () => {
      Cookies.remove("sesion");
      if (isMicrosoftLoginDisabled) {
        if (legacyLoginUrl) {
          window.location.replace(legacyLoginUrl);
          return;
        }
        setMessage("El acceso con Microsoft esta deshabilitado.");
        return;
      }
      navigate("/login_plus", { replace: true });
    };

    const redirectToLegacy = () => {
      if (totales > 0) {
        window.location.href = "https://gestion.seranestpharma.com/tareas.php?a=mt";
        return;
      }
      window.location.href = "https://gestion.seranestpharma.com/index.php?a=home&mapa=1";
    };

    const resolveLegacyLogin = async () => {
      if (!id_usuario) {
        redirectToMicrosoft();
        return;
      }

      try {
        const response = await postPlusLegacyLogin({
          id_usuario,
          inicio,
          fin,
        });

        if (!mounted) return;

        const authData = response?.data || {};
        const sesion = authData?.sesion;
        if (!sesion) {
          throw new Error("La respuesta del servidor no incluyo la sesion.");
        }

        Cookies.set("sesion", JSON.stringify(sesion));
        redirectToLegacy();
      } catch (error) {
        if (!mounted) return;
        setMessage("Redirigiendo a inicio de sesion Microsoft...");
        redirectToMicrosoft();
      }
    };

    resolveLegacyLogin();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  return <p>{message}</p>;
};

export default Login;
